module.exports = __webpack_public_path__ + "static/media/6.2f523342.jpg";